// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-filter-opener-loading[data-v-aadba392]{justify-content:space-between;padding:13px 20px}.search-filter-opener-loading-button[data-v-aadba392]{width:48%;height:35px;background-color:#e1e1e1;border-radius:3em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
